(() => {
  if (window.__yyCartSmartSellLoaded) return;
  window.__yyCartSmartSellLoaded = true;

  const FREE_SHIPPING = 99900;
  const money = cents => new Intl.NumberFormat('en-IN',{
    style:'currency',
    currency:window.Shopify?.currency?.active||'INR',
    maximumFractionDigits:0
  }).format((Number(cents)||0)/100);

  const rootUrl = () => window.Shopify?.routes?.root || '/';
  const normalize = value => String(value||'').toLowerCase();

  const contexts = {
    yoga:{
      keywords:['strap','block','towel','grip sock','pilates sock','massage','recovery'],
      badge:'Yoga add-on',
      reason:'A practical companion for your yoga setup',
      bundle:'Yoga support pair'
    },
    meditation:{
      keywords:['yoga mat','grip sock','acupressure','strap','block'],
      badge:'Mindful add-on',
      reason:'Useful alongside a meditation routine',
      bundle:'Mindful practice pair'
    },
    recovery:{
      keywords:['massage','roller','acupressure','joint','comfort pad','towel'],
      badge:'Recovery add-on',
      reason:'Complements mobility and recovery days',
      bundle:'Recovery support pair'
    },
    strength:{
      keywords:['glove','resistance','band','gripper','towel','wrist','bottle'],
      badge:'Strength add-on',
      reason:'Useful alongside your strength setup',
      bundle:'Strength support pair'
    },
    general:{
      keywords:['towel','bottle','bag','recovery','strap'],
      badge:'Useful add-on',
      reason:'A practical addition to your routine',
      bundle:'Everyday training pair'
    }
  };

  const contextFrom = root => {
    const serverContext=normalize(root.dataset.cartContext||'');
    if(['yoga','strength','recovery','meditation'].includes(serverContext)) return serverContext;
    const text=normalize((root.dataset.productType||'')+' '+(root.dataset.productTitle||''));
    if(/zafu|meditation|cushion/.test(text)) return 'meditation';
    if(/yoga|mat|pilates|block|strap/.test(text)) return 'yoga';
    if(/roller|massage|recovery|acupressure|mobility|comfort pad/.test(text)) return 'recovery';
    if(/pull.?up|mudgar|band|gripper|weight|strength|glove|wrist/.test(text)) return 'strength';
    return 'general';
  };

  const cheapestAvailableVariant = product => {
    const variants=Array.isArray(product.variants)?product.variants.filter(v=>v.available):[];
    return variants.sort((a,b)=>(Number(a.price)||0)-(Number(b.price)||0))[0]||null;
  };

  const productFamily = product => normalize(product.title||'')
    .replace(/\b(black|white|green|forest|stone|grey|gray|blue|purple|red|yellow|beige|cream|navy|plum|aubergine|sienna|sage|glacier|natural|oat|smoke|frost|midnight|himalayan|rush)\b/g,' ')
    .replace(/\b\d+(?:\.\d+)?\s*(kg|g|gm|gsm|mm|cm|l|litre|liter)\b/g,' ')
    .replace(/[^a-z0-9]+/g,' ')
    .replace(/\s+/g,' ')
    .trim();

  const getCart=async()=>{
    try{
      const response=await fetch(rootUrl()+'cart.js',{headers:{Accept:'application/json'}});
      if(!response.ok)return null;
      return await response.json();
    }catch(e){
      return null;
    }
  };

  const scoreProduct=(product,context,gap)=>{
    const rule=contexts[context]||contexts.general;
    const haystack=normalize(
      (product.title||'')+' '+(product.product_type||'')+' '+((product.tags||[]).join?.(' ')||'')
    );

    let relevance=0;
    rule.keywords.forEach((keyword,index)=>{
      if(haystack.includes(keyword)) relevance+=Math.max(2,7-index);
    });

    const variant=cheapestAvailableVariant(product);
    const price=Number(variant?.price||0);
    let score=relevance;

    if(relevance>0&&gap>0&&price>=gap){
      const overshoot=price-gap;
      if(overshoot<=15000)score+=10;
      else if(overshoot<=35000)score+=7;
      else if(overshoot<=60000)score+=4;
    }

    if(relevance>0&&price>0&&price<=99900)score+=1;
    return {score,relevance};
  };

  const createImage=(product,size=80)=>{
    const wrap=document.createElement('a');
    wrap.className='yy-cart-smart-product__image';
    wrap.href=product.url;
    wrap.setAttribute('aria-label',product.title);

    if(product.featured_image){
      const img=document.createElement('img');
      img.src=product.featured_image;
      img.alt=product.title;
      img.loading='lazy';
      img.width=size;
      img.height=size;
      wrap.appendChild(img);
    }
    return wrap;
  };

  const addItems=async(items,root,button)=>{
    if(!items.length||button.disabled)return;
    const original=button.textContent;
    button.disabled=true;
    button.textContent=items.length>1?'Adding both…':'Adding…';

    try{
      const response=await fetch(rootUrl()+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({
          items:items.map(item=>({id:item.variant.id,quantity:1}))
        })
      });

      if(!response.ok)throw new Error('Unable to add recommendation');

      button.textContent='Added ✓';

      const inDrawer=Boolean(root.closest('m-cart-drawer'));
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:inDrawer}}));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      if(!inDrawer&&location.pathname.replace(/\/+$/,'')==='/cart'){
        setTimeout(()=>location.reload(),500);
      }
    }catch(error){
      console.error('YETI YOGI smart cart add error:',error);
      button.disabled=false;
      button.textContent='Try again';
      return;
    }

    setTimeout(()=>{
      button.disabled=false;
      button.textContent=original;
    },1800);
  };

  const renderFocusedUpsell=(root,entry,context,gap)=>{
    const holder=root.querySelector('[data-yy-focused-upsell]');
    const content=root.querySelector('[data-yy-focused-upsell-content]');
    if(!holder||!content||!entry){
      if(holder)holder.hidden=true;
      return;
    }

    const rule=contexts[context]||contexts.general;
    const price=Number(entry.variant.price||0);
    const unlocksShipping=entry.relevance>0&&gap>0&&price>=gap&&(price-gap)<=50000;

    const card=document.createElement('article');
    card.className='yy-cart-upsell__card';

    const image=createImage(entry.product,86);

    const body=document.createElement('div');
    body.className='yy-cart-upsell__body';

    const badge=document.createElement('span');
    badge.className='yy-cart-upsell__badge';
    badge.textContent=unlocksShipping?'Unlocks free shipping':'Best add-on';

    const title=document.createElement('a');
    title.className='yy-cart-upsell__title';
    title.href=entry.product.url;
    title.textContent=entry.product.title;

    const reason=document.createElement('p');
    reason.className='yy-cart-upsell__reason';
    reason.textContent=unlocksShipping
      ? 'Gets this cart past the ₹999 free-shipping threshold'
      : rule.reason;

    const row=document.createElement('div');
    row.className='yy-cart-upsell__row';

    const priceEl=document.createElement('strong');
    priceEl.className='yy-cart-upsell__price';
    priceEl.textContent=money(price);

    const button=document.createElement('button');
    button.type='button';
    button.className='yy-cart-upsell__add';
    button.textContent='Add';
    button.setAttribute('aria-label','Add '+entry.product.title+' to cart');
    button.addEventListener('click',()=>addItems([entry],root,button));

    row.append(priceEl,button);
    body.append(badge,title,reason,row);
    card.append(image,body);

    content.replaceChildren(card);
    holder.hidden=false;
  };

  const renderBundle=(root,entries,context)=>{
    const holder=root.querySelector('[data-yy-bundle]');
    const itemsHolder=root.querySelector('[data-yy-bundle-items]');
    const totalEl=root.querySelector('[data-yy-bundle-total]');
    const titleEl=root.querySelector('[data-yy-bundle-title]');
    const addButton=root.querySelector('[data-yy-bundle-add]');

    if(!holder||!itemsHolder||!totalEl||!titleEl||!addButton||entries.length<2){
      if(holder)holder.hidden=true;
      return;
    }

    const pair=entries.slice(0,2);
    const rule=contexts[context]||contexts.general;
    titleEl.textContent=rule.bundle;

    const fragment=document.createDocumentFragment();

    pair.forEach(entry=>{
      const card=document.createElement('article');
      card.className='yy-cart-bundle__item';

      const image=createImage(entry.product,62);

      const body=document.createElement('div');
      body.className='yy-cart-bundle__item-body';

      const title=document.createElement('a');
      title.className='yy-cart-bundle__item-title';
      title.href=entry.product.url;
      title.textContent=entry.product.title;

      const price=document.createElement('strong');
      price.className='yy-cart-bundle__item-price';
      price.textContent=money(entry.variant.price);

      body.append(title,price);
      card.append(image,body);
      fragment.appendChild(card);
    });

    itemsHolder.replaceChildren(fragment);
    totalEl.textContent=money(pair.reduce((sum,entry)=>sum+Number(entry.variant.price||0),0));

    addButton.onclick=()=>addItems(pair,root,addButton);
    holder.hidden=false;
  };

  const hydrate=async root=>{
    if(!root)return;

    const productId=root.dataset.productId;
    if(!productId)return;

    if(root.dataset.yyLoaded==='true')return;
    root.dataset.yyLoaded='loading';
    root.hidden=false;

    try{
      const [relatedResponse,complementaryResponse,cart]=await Promise.all([
        fetch(
          rootUrl()+'recommendations/products.json?product_id='+encodeURIComponent(productId)+'&limit=10&intent=related',
          {headers:{Accept:'application/json'}}
        ),
        fetch(
          rootUrl()+'recommendations/products.json?product_id='+encodeURIComponent(productId)+'&limit=10&intent=complementary',
          {headers:{Accept:'application/json'}}
        ).catch(()=>null),
        getCart()
      ]);

      if(!relatedResponse.ok)throw new Error('Recommendation request failed');

      const relatedData=await relatedResponse.json();
      const complementaryData=complementaryResponse&&complementaryResponse.ok
        ? await complementaryResponse.json()
        : {products:[]};

      const merged=[];
      const seenProductIds=new Set();

      [...(complementaryData.products||[]),...(relatedData.products||[])].forEach(product=>{
        const key=String(product.id||product.handle||'');
        if(!key||seenProductIds.has(key))return;
        seenProductIds.add(key);
        merged.push(product);
      });

      const cartHandles=new Set(
        String(root.dataset.cartHandles||'')
          .split('|')
          .map(normalize)
          .filter(Boolean)
      );

      const context=contextFrom(root);
      const gap=cart&&Number(cart.total_price)<FREE_SHIPPING
        ? FREE_SHIPPING-Number(cart.total_price)
        : 0;

      const ranked=merged
        .filter(product=>!cartHandles.has(normalize(product.handle)))
        .map(product=>{
          const scoring=scoreProduct(product,context,gap);
          return {
            product,
            variant:cheapestAvailableVariant(product),
            family:productFamily(product),
            score:scoring.score,
            relevance:scoring.relevance
          };
        })
        .filter(entry=>entry.variant)
        .sort((a,b)=>b.score-a.score);

      const diverse=[];
      const families=new Set();

      for(const entry of ranked){
        const family=entry.family||normalize(entry.product.handle);
        if(families.has(family))continue;
        families.add(family);
        diverse.push(entry);
        if(diverse.length===5)break;
      }

      const focused=diverse.find(entry=>entry.relevance>0)||diverse[0]||null;
      const bundleCandidates=diverse.filter(entry=>entry!==focused&&entry.relevance>0);
      const fallbackBundle=diverse.filter(entry=>entry!==focused);
      const bundle=bundleCandidates.length>=2
        ? bundleCandidates.slice(0,2)
        : fallbackBundle.slice(0,2);

      renderFocusedUpsell(root,focused,context,gap);
      renderBundle(root,bundle,context);

      if(!focused&&bundle.length<2){
        root.hidden=true;
        root.dataset.yyLoaded='empty';
        return;
      }

      root.dataset.yyLoaded='true';
    }catch(error){
      console.error('YETI YOGI smart cart recommendation error:',error);
      root.hidden=true;
      root.dataset.yyLoaded='error';
    }
  };

  const scan=()=>{
    document.querySelectorAll('[data-yy-cart-cross-sell]').forEach(root=>{
      if(root.dataset.yyLoaded==='loading')return;
      hydrate(root);
    });
  };

  const resetAndScan=()=>{
    document.querySelectorAll('[data-yy-cart-cross-sell]').forEach(root=>{
      root.dataset.yyLoaded='';
    });
    requestAnimationFrame(scan);
    setTimeout(scan,350);
    setTimeout(scan,900);
    setTimeout(scan,1500);
  };

  document.addEventListener('cart:updated',resetAndScan);
  document.addEventListener('cart:refresh',resetAndScan);

  const drawer=document.getElementById('MinimogCartDrawer');
  if(drawer&&'MutationObserver' in window){
    let observerTimer=null;
    const observer=new MutationObserver(mutations=>{
      if(!mutations.some(m=>m.type==='childList'&&m.addedNodes.length))return;
      clearTimeout(observerTimer);
      observerTimer=setTimeout(scan,100);
    });
    observer.observe(drawer,{childList:true,subtree:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',resetAndScan,{once:true});
  }else{
    resetAndScan();
  }
})();